var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-avatar-group',{attrs:{"overlap":"0.55"}},[_vm._l((_vm.images),function(i){return _c('b-avatar',{key:i,attrs:{"src":i}})}),_c('b-avatar',[_vm._v("+31")])],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }